module.exports = __webpack_public_path__ + "empty_record.png?108b0c285583c79b6bbfe752d3a413bd";